
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/en/accessibility",
      function () {
        return require("private-next-pages/de/en/accessibility.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/de/en/accessibility"])
      });
    }
  